import styled from 'styled-components'

export const ContainerContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`
interface RowLineProps {
  isFilled: boolean
  isFull: boolean
}

export const RowLine = styled.div<RowLineProps>`
  position: relative;
  width: 100%;
  height: 1px;
  background: ${props =>
    props.isFull
      ? props.theme.colors.color00559766
      : `linear-gradient(to right, ${
          props.isFilled ? props.theme.colors.color00559766 : '#2D313933'
        } 50%, transparent 50%)`};
  background-position: center;
  background-size: 18px 1px;
  background-repeat: repeat-x;
`
